<div class="admin-container" [hidden]="!isLoaded">
  <mat-toolbar class="no-background">
    <span>【管理者用】</span>
    <mat-select [(ngModel)]="category" (selectionChange)="load()" style="border: 1px solid #999; border-radius: 8px; padding: 8px; width: 200px;">
      <mat-option *ngFor="let cat of InquiryCategory" [value]="cat">
        {{ cat }}
      </mat-option>
    </mat-select>

    <button mat-raised-button color="primary" (click)="download($event)" type="button" style="margin-left: 32px;">
      全データをダウンロード
    </button>

    <span class="spacer"></span>

    <mat-checkbox [(ngModel)]="showOnlyUnassigned" (change)="onToggleOnlyAssigned()" style="margin-right: 32px;">
      未割当のみ表示
    </mat-checkbox>
    <mat-checkbox [(ngModel)]="showCompleted" (change)="onToggleCompleted()" style="margin-right: 32px;">
      回答済・処理済・出金済・完了・取消も表示
    </mat-checkbox>
    <a mat-button class="add-link" routerLink="/admin">
      <mat-icon>arrow_back</mat-icon>戻る
    </a>
  </mat-toolbar>

  <div class="list-container" [hidden]="!showGrid">
    <ag-grid-angular
      #grid
      class="ag-theme-alpine"
      style="width: 100%; height: calc(100vh - 80px);"
      [localeText]="localeText"
      [defaultColDef]="defaultColDef"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [pagination]="true"
      [paginationPageSize]="pageSize"
      [paginationPageSizeSelector]="paginationPageSizeSelector"
      [getRowId]="getRowId"
      (gridReady)="onGridReady($event)"
      (firstDataRendered)="onFirstDataRendered($event)"
      (filterChanged)="onFilterOrSortChanged()"
      (sortChanged)="onFilterOrSortChanged()"
      (paginationChanged)="onFilterOrSortChanged()"
      (rowClicked)="onRowClicked($event)">
    </ag-grid-angular>
  </div>
</div>
